export default [
    {
        name: 'MAWB',
        value: 's_mawb',
        customWidth: 135,
        s_mawb: true
    },
    {
        name: 'Flight ID',
        value: 's_flight_id',
        customWidth: 210
    },
    {
        name: 'Consignee',
        value: 's_name'
    },
    {
        name: 'Type',
        value: 's_notification_type',
        mediumWidth: true
    },
    {
        name: 'Created',
        value: 't_created',
        datetime: true,
        utc: true
    },
    {
        name: 'Created by',
        value: 's_created_by',
        email: true,
        medLargeWidth: true
    }
]